export default __webpack_public_path__ + "static/media/dfmDifferentiel.b6079dd5.png";